
import {Component, Prop} from "vue-property-decorator";
import Vue from "vue";
import DossierFile from "@pazion/pazion-core/src/views/dossier/parts/DossierFile.vue";
import {IDossierFile} from "@pazion/pazion-core/src/models/dossier.model";
import {getIconForFileType} from "@pazion/pazion-core/src/helpers/Helper";

@Component({
  methods: {getIconForFileType},
  components: {DossierFile},
})
export default class FileTab extends Vue {

  @Prop({default: 0})
  public dossierId!: number;

  @Prop({default: true})
  public loading!: boolean;

  @Prop({default: []})
  public files!: IDossierFile[];

  public tree=[];

  async refreshData(){
    this.$emit('refreshDataRequest');
  }


}
